import { useLocation, Link } from "react-router";
import "./Nav.css";

// --------------------------------------------------------------------------------------

export default function Nav() {
	const { pathname } = useLocation();

	return (
		<nav>
			<ol>
				<li>
					<a
						href="TODO"
						target="_blank"
						rel="noopener noreferrer"
						className="unstyled-link"
					>
						Article
					</a>
				</li>

				<li>
					<a
						href="TODO"
						target="_blank"
						rel="noopener noreferrer"
						className="unstyled-link"
					>
						Report
					</a>
				</li>

				<li>
					<Link
						to="/"
						className={pathname === "/" ? "c-blue-accent" : "unstyled-link"}
					>
						Calculator
					</Link>
				</li>

				{/* <li>
					<a href="TODO" target="_blank" rel="noopener noreferrer">
						Quiz
					</a>
				</li> */}

				<li>
					<Link
						to="/build"
						className={
							pathname === "/build" ? "c-blue-accent" : "unstyled-link"
						}
					>
						Build
					</Link>
				</li>
			</ol>
		</nav>
	);
}
